<template>
  <Modal
    :title="$t('global.ssl-certificate-name', { name: data.cert.commonName })"
    @close="close"
    :hide-footer="true"
    size="large"
  >
    <template #body>
      <div>
        <LoadingState v-if="status.isLoading" :size="50" />
        <div v-else>
          <h4>{{ $t("global.certificate") }} <CopyToClipboard :text="cert.crt" /></h4>
          <FormTextArea name="crt" v-model="cert.crt" label="" :rows="10" />
          <h4 v-if="cert.chainCerts.length > 0">
            {{ $t("global.chain-certificates") }} <CopyToClipboard :text="cert.chainCerts" />
          </h4>
          <FormTextArea
            v-if="cert.chainCerts.length > 0"
            name="chain_crts"
            v-model="cert.chainCerts"
            label=""
            :rows="10"
          />
          <h4>{{ $t("global.private-key") }} <CopyToClipboard :text="cert.key" /></h4>
          <FormTextArea name="key" v-model="cert.key" label="" :rows="10" />
          <div class="form-buttons">
            <Btn class="mr-2" variant="light" type="button" @click="close">
              {{ $t("global.close") }}
            </Btn>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import CopyToClipboard from "@/components/display/CopyToClipboard";
import FormTextArea from "@/components/display/form/FormTextArea";
import LoadingState from "@/components/display/LoadingState";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "ShowCertModal",
  props: {
    data: Object,
  },
  components: {
    Btn,
    CopyToClipboard,
    FormTextArea,
    LoadingState,
    Modal,
  },
  setup(props, { emit }) {
    const cert = computed(() => store.state.certificates.item);
    const status = computed(() => store.state.certificates.status);
    const close = () => emit("close");

    onMounted(() => {
      store.dispatch("certificates/get", props.data.cert.id, {});
    });

    return {
      cert,
      close,
      status,
    };
  },
};
</script>
